import { Script } from 'gatsby';

import type { FC, ReactNode } from 'react';

interface GeneralHeadProps {
  children: ReactNode | ReactNode[];
}

const GeneralHead: FC<GeneralHeadProps> = ({ children }) => (
  <>
    <Script id="hs-script-loader" strategy="post-hydrate" src="//js.hs-scripts.com/21817597.js" />
    {children}
  </>
);

export default GeneralHead;
